"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbrManager = void 0;
var abr_to_player_1 = require("./players/abr-to-player");
var retry_policy_manager_1 = require("./retry-policy-manager");
var sort_and_filter_tracks_1 = require("./sort-and-filter-tracks");
var AbrManager = /** @class */ (function () {
    function AbrManager(logger, abrAlgorithm, bufferAssessment, bandwidthEstimator, latencyEstimator, roundTripTimeEstimator, retryPolicyConfig) {
        var _a;
        this.abrAlgorithm = abrAlgorithm;
        this.bufferAssessment = bufferAssessment;
        this.bandwidthEstimator = bandwidthEstimator;
        this.latencyEstimator = latencyEstimator;
        this.roundTripTimeEstimator = roundTripTimeEstimator;
        this.retryPolicyConfig = retryPolicyConfig;
        this.nextSegmentDurationSeconds = 0;
        if ((_a = this.retryPolicyConfig) === null || _a === void 0 ? void 0 : _a.shouldUseDynamicRetryConfig) {
            this.retryPolicyManager = new retry_policy_manager_1.RetryPolicyManager(logger, this.bufferAssessment, this.retryPolicyConfig);
        }
        this.logger = logger.withContext('ABR Manager');
        this.logger.info("ABR selected: ".concat(this.abrAlgorithm.name));
    }
    AbrManager.prototype.registerAbrToPlayer = function (abrToPlayer) {
        var _a;
        this.abrToPlayer = abrToPlayer;
        this.abrToPlayer.onPlayerStateChanged(this.playerStateEvent.bind(this));
        this.abrToPlayer.onPlaybackRateChanged(this.notifiedPlaybackRateChange.bind(this));
        (_a = this.retryPolicyManager) === null || _a === void 0 ? void 0 : _a.registerAbrToPlayer(this.abrToPlayer);
        this.bufferAssessment.registerAbrToPlayer(this.abrToPlayer);
    };
    AbrManager.prototype.setBandwidthEstimationConfig = function (config) {
        this.bandwidthEstimator.reinitialise(config);
    };
    AbrManager.prototype.getRecommendedTracks = function () {
        var combinedTrack = this.abrAlgorithm.getRecommendedTracks(this.nextSegmentDurationSeconds);
        if (!combinedTrack) {
            return null;
        }
        this.logger.info("Chose audio track (id: ".concat(combinedTrack.audioTrack.id, ", bandwidth: ").concat(combinedTrack.audioTrack.bandwidth, ")"));
        this.logger.info("Chose video track (id: ".concat(combinedTrack.videoTrack.id, ", bandwidth: ").concat(combinedTrack.videoTrack.bandwidth, ")"));
        return combinedTrack;
    };
    AbrManager.prototype.setAvailableTracks = function (combinedTracks) {
        var sortedTracks = (0, sort_and_filter_tracks_1.sortAndFilterTracks)(combinedTracks);
        this.logger.verbose('Set Tracks: ', sortedTracks.map(function (t) { return "Video Bandwidth: ".concat(t.videoTrack.bandwidth, " | Audio Bandwidth: ").concat(t.audioTrack.bandwidth); }));
        this.abrAlgorithm.setTracksAscending(sortedTracks);
    };
    AbrManager.prototype.submitRequestSample = function (requestInfo) {
        this.latencyEstimator.sample(requestInfo.latencyMs, requestInfo.timeRecorded, requestInfo.sampleType);
        this.roundTripTimeEstimator.sample(requestInfo.downloadTimeMs, requestInfo.timeRecorded, requestInfo.sampleType);
    };
    AbrManager.prototype.submitBandwidthSample = function (sample) {
        this.bandwidthEstimator.sample(sample.timeToDownloadMs, sample.timeRecorded, sample.numBytes);
        if (this.abrAlgorithm.shouldWaitForBandwidth && !this.bandwidthEstimator.hasGoodEstimate()) {
            return;
        }
        this.bufferAssessment.refreshBufferState();
    };
    AbrManager.prototype.submitSegmentDurationSeconds = function (segmentDurationSeconds) {
        this.nextSegmentDurationSeconds = segmentDurationSeconds;
        this.bandwidthEstimator.setSegmentDurationSeconds(segmentDurationSeconds);
    };
    AbrManager.prototype.notifiedPlaybackRateChange = function (rate) {
        this.logger.verbose("playback rate changed: ".concat(rate));
        this.abrAlgorithm.notifiedPlaybackRateChange(rate);
    };
    AbrManager.prototype.getBandwidthEstimator = function () {
        return this.bandwidthEstimator;
    };
    AbrManager.prototype.destroy = function () {
        var _a, _b;
        this.abrAlgorithm.destroy();
        (_a = this.retryPolicyManager) === null || _a === void 0 ? void 0 : _a.destroy();
        this.bufferAssessment.destroy();
        this.bandwidthEstimator.destroy();
        this.latencyEstimator.destroy();
        this.roundTripTimeEstimator.destroy();
        (_b = this.abrToPlayer) === null || _b === void 0 ? void 0 : _b.destroy();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    AbrManager.prototype.playerStateEvent = function (playerState) {
        var _a, _b;
        switch (playerState) {
            case abr_to_player_1.PlayerState.SEEKING:
            case abr_to_player_1.PlayerState.STOPPED:
                this.bufferAssessment.refreshBufferState(true);
                break;
        }
        if (this.lastPlayerState !== playerState) {
            (_b = (_a = this.abrAlgorithm).playerStateChanged) === null || _b === void 0 ? void 0 : _b.call(_a, playerState);
        }
        this.lastPlayerState = playerState;
    };
    return AbrManager;
}());
exports.AbrManager = AbrManager;
